import { Link } from "react-router-dom";
import type { Series } from "@/mocks/series";

export default function SeriesCard({ series }: { series: Series }) {
  return (
    <Link
      to={`/shijian/${series.slug}`}
      className="group flex flex-col overflow-hidden rounded-2xl border border-background-200 bg-background-50 transition hover:-translate-y-1 hover:border-primary-300"
    >
      <div className="relative h-44 w-full overflow-hidden">
        <img
          src={series.cover}
          alt={`${series.title}时间线封面`}
          className="h-full w-full object-cover transition duration-500 group-hover:scale-105"
        />
        <span className="absolute left-3 top-3 rounded-full bg-primary-500 px-3 py-1 text-xs text-background-50">
          {series.category}
        </span>
        <span
          className={`absolute right-3 top-3 rounded-full px-2.5 py-1 text-xs ${
            series.status === "已完结" ? "bg-background-50/90 text-foreground-700" : "bg-accent-500 text-background-50"
          }`}
        >
          {series.status}
        </span>
      </div>
      <div className="flex flex-1 flex-col p-5">
        <h3 className="text-base font-semibold text-foreground-950 transition group-hover:text-primary-600">
          {series.title}
        </h3>
        <p className="mt-2 flex-1 text-sm leading-6 text-foreground-600 line-clamp-2">{series.tagline}</p>
        <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3 text-xs text-foreground-500">
          <span className="flex items-center gap-1 whitespace-nowrap">
            <i className="ri-fire-line text-accent-500"></i>
            {series.heat}
          </span>
          <span className="whitespace-nowrap">{series.period}</span>
          <span className="flex items-center gap-1 text-primary-600">
            追更时间线 <i className="ri-arrow-right-line transition group-hover:translate-x-1"></i>
          </span>
        </div>
      </div>
    </Link>
  );
}